
import { UrlField } from "../../field-types/";

export default {
  props: {
    field: {
      type: UrlField,
      required: true,
    },
    inputProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      hasFocus: false,
    };
  },
};
